import React from "react";
import { Box } from "@mui/material";

const Logos: React.FC = () => {
  return (
    <>
      <Box className="logo">
        <img src="/images/logo.png" width="auto" height="195px" alt="isologo" />
      </Box>
      <Box className="name">
        <img
          src="/images/ma.png"
          width="auto"
          height="76px"
          alt="logo de la empresa"
        />
      </Box>
    </>
  );
};

export default Logos;
